import React from "react";
import TimeLine from "./pages/projects/projects-timeline.component";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import Home from "./home/Home";
import Footer from "./pages/footer/Footer";
import Food from "./pages/work/Food";
import Alpha from "./pages/work/Alpha";
import Ciclo from "./pages/work/Ciclo";

const App = () => {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/hungry">
            <Food />
            <Footer />
          </Route>
          <Route path="/alpha">
            <Alpha/>
            <Footer />
          </Route>
          <Route path="/ciclo">
            <Ciclo/>
            <Footer />
          </Route>
          <Route path="/">
            <Home />
            <TimeLine />
            <Footer />
          </Route>
        </Switch>
      </Router>
    </div>
  );
};

export default App;
